const baseUrl =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:80/api/v1"

export function login(username, password) {
  return fetch(`${baseUrl}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Login failed")
    }
    return response
  })
}
export function confirmCode(username, password, verificationCode) {
  return fetch(`${baseUrl}/auth/code`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password, verificationCode }),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Code confirmation failed")
    }
    return response.json()
  })
}

export function getUsers() {
  return fetch(`${baseUrl}/users`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to fetch users")
    }
    return response.json()
  })
}
export function getOrders() {
  return fetch(`${baseUrl}/orders`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to fetch orders")
    }
    return response.json()
  })
}
export function getPendingOrders() {
  return fetch(`${baseUrl}/orders?status=created`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to fetch pending orders")
    }
    return response.json()
  })
}

export function getOrder(orderId) {
  return fetch(`${baseUrl}/orders?orderId=${orderId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to fetch order")
    }
    return response.json()
  })
}

export function editOrder(order, orderNumber) {
  return fetch(`${baseUrl}/orders/edit?orderNumber=${orderNumber}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(order),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to edit order")
    }
    return response.json()
  })
}
export function closeOrder(orderNumber, txId) {
  return fetch(
    `${baseUrl}/orders/close?orderNumber=${orderNumber}&txId=${txId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  ).then(response => {
    if (!response.ok) {
      throw new Error("Failed to close order")
    }
    return response
  })
}
export function cancelOrder(orderNumber) {
  return fetch(
    `${baseUrl}/orders?orderNumber=${orderNumber}&status=cancelled`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  ).then(response => {
    if (!response.ok) {
      throw new Error("Failed to cancel order")
    }
    return response
  })
}

export function getConfig() {
  return fetch(`${baseUrl}/branch/config`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to fetch configuration")
    }
    return response.json()
  })
}
export function getBalance() {
  return fetch(`${baseUrl}/branch/balance`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to fetch balance")
    }
    return response.json()
  })
}
export function generateReport(startDate, endDate, format = "pdf", includeOfficeExpenses = false) {
  const params = new URLSearchParams()
  if (startDate) params.append("startDate", startDate)
  if (endDate) params.append("endDate", endDate)
  if (format) params.append("format", format)
  params.append("includeOfficeExpenses", includeOfficeExpenses)

  return fetch(`${baseUrl}/report?${params.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to generate report")
    }
    return response.json()
  })
}

export function createManualOrder(orderData) {
  return fetch(`${baseUrl}/orders/manual`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(orderData),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to create manual order")
    }
    return response.json()
  })
}

export function generateRefundCode(orderNumber) {
  return fetch(`${baseUrl}/orders/refund/code?orderNumber=${orderNumber}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to generate refund code")
    }
    return response.text()
  })
}

export function refundOrder(orderNumber, code) {
  return fetch(`${baseUrl}/orders/refund?orderNumber=${orderNumber}&code=${code}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to refund order")
    }
    return response
  })
}

// Office Expenses API
export function createOfficeExpense(expenseData) {
  return fetch(`${baseUrl}/office-expenses`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(expenseData),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to create expense")
    }
    return response.json()
  })
}

export function getAllExpenses() {
  return fetch(`${baseUrl}/office-expenses`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to get expenses")
    }
    return response.json()
  })
}

export function generateExpenseRefundCode(expenseNumber) {
  return fetch(`${baseUrl}/office-expenses/${expenseNumber}/generate-refund-code`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to generate refund code")
    }
    return response.text()
  })
}

export function refundExpense(expenseNumber, code) {
  return fetch(`${baseUrl}/office-expenses/${expenseNumber}/refund`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ code }),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to refund expense")
    }
    return response.text()
  })
}

// Balance Advances API
export function createBalanceAdvance(advanceData) {
  return fetch(`${baseUrl}/balance-advances`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(advanceData),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to create advance")
    }
    return response.json()
  })
}

export function getAllAdvances() {
  return fetch(`${baseUrl}/balance-advances`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to get advances")
    }
    return response.json()
  })
}

export function generateAdvanceReturnCode(advanceNumber) {
  return fetch(`${baseUrl}/balance-advances/${advanceNumber}/generate-return-code`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to generate return code")
    }
    return response.text()
  })
}

export function returnAdvance(advanceNumber, code) {
  return fetch(`${baseUrl}/balance-advances/${advanceNumber}/return`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ code }),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Failed to return advance")
    }
    return response.text()
  })
}
